const cart = {
  title: () => 'italist | Cart',
  description: () =>
    "italist is the first platform to offer direct-to-consumer imports of worldwide luxury goods exclusively from Italy. The same high-quality products you'd find on other sites are available at a lower retail prices.",
};

export default cart;
